module.exports = __webpack_public_path__ + "static/media/view4.525a1832.jpg";